import React, { useState, useEffect } from "react";
import {
  collection,
  orderBy,
  query,
  where,
  limit,
  doc,
} from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import Leaderboard from "components/leaderboard";
import { useTranslation } from "react-i18next";
import { useLeague } from "context/leagueContext";
import { useRound } from "context/roundContext";

const KnockoutLeaderboard = () => {
  const [userList, setUserList] = useState([]);
  const [roundUserList, setRoundUserList] = useState([]);

  const {
    state: { leagueInfo },
  } = useLeague();
  const {
    state: { currentRound, predictionLeagueRoundData },
  } = useRound();

  const { t } = useTranslation();
  const firestore = useFirestore();

  const userCollection = collection(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/users/"
  );
  const userCollectionQuery = query(userCollection);
  const { status: userCollectionStatus, data: userCollectionList } =
    useFirestoreCollectionData(userCollectionQuery, {
      idField: "id",
    });
  useEffect(() => {
    if (userCollectionList) {
      setUserList(userCollectionList);
    }
  }, [userCollectionList]);

  const roundLeaderboardCollection = collection(
    firestore,
    "userTournaments/" +
      leagueInfo?.id +
      "/rounds/" +
      currentRound.id +
      "/users"
  );
  const roundLeaderboardQuery = query(
    roundLeaderboardCollection,
    orderBy("points", "desc")
  );
  const { status: roundLeaderboardStatus, data: roundLeaderboardList } =
    useFirestoreCollectionData(roundLeaderboardQuery, {
      idField: "id",
    });
  useEffect(() => {
    if (roundLeaderboardList && userCollectionList) {
      const test = roundLeaderboardList.filter(function (user) {
        let userData = userCollectionList.find((x) => x.id === user.id);

        if (userData?.gameOver) {
          if (
            userData?.passedRounds?.some((el) => el === currentRound.id) ||
            userData?.exitRound === currentRound.id
          ) {
            return user;
          } else return;
        } else return user;
      });

      setRoundUserList(test);
    }
  }, [roundLeaderboardList, userCollectionList]);

  return userList?.length ? (
    <>
      <div className="block uppercase tracking-wide text-xs mb-1 pl-2 text-textPrimary">
        {/* {t("tournament.leaderboard.round")} 5 */}
        {t("tournament.leaderboard.round")}
      </div>
      <div className="rounded-md bg-white mb-4 ">
        <Leaderboard
          users={roundUserList}
          isLoading={roundLeaderboardStatus === "loading"}
          settled={currentRound?.settled}
          roundInfo={predictionLeagueRoundData}
          isRound={true}
        />
      </div>
    </>
  ) : (
    <></>
  );
};

export default KnockoutLeaderboard;
